// extracted by mini-css-extract-plugin
module.exports = {"column":"styles_column__G9qQ4","title":"styles_title__IdDw7"};